import { render, staticRenderFns } from "./printPlan.vue?vue&type=template&id=1284a575&scoped=true"
import script from "./printPlan.vue?vue&type=script&lang=js"
export * from "./printPlan.vue?vue&type=script&lang=js"
import style0 from "./printPlan.vue?vue&type=style&index=0&id=1284a575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284a575",
  null
  
)

export default component.exports